/** A journal's impact factor, or `null` for the journal list's "unknown" (`0`). */
export function journalImpactFactor(journal: {
  impact_factor: number;
}): number | null {
  return journal.impact_factor === 0 ? null : journal.impact_factor;
}
